import { INSTRUCTOR_BOARD_ROUTE } from "../../helper/Constants";
import "../../../../locales/i18n";
import { useTranslation } from "react-i18next";

export const useLandingPageCards = () => {
  const { t } = useTranslation();

  return [
    {
      title: t("landing_card_title"),
      description: t("landing_card_description"),
      imageUrl: "/resources/cs-landing.png",
      route: INSTRUCTOR_BOARD_ROUTE,
      time: 1500,
      buttonText: t("landing_card_button_text"),
      buttonVariant: "contained",
    },
  ];
};
